<template>
  <div>
    <!-- Bannière avec animation -->
    <div class="banner text-white d-flex align-items-center">
      <!-- Image animée -->
      <img
        src="@/assets/container_only.png"
        alt="Container"
        class="animated-image"
      />
      <!-- Texte Bienvenue -->
      <div class="welcome-text">
        <h5 class="fw-bold">
          Tout pour vos projets : location de containers, terrassement,
          transport et matériaux.
        </h5>
        <p class="lead">
          Que vous soyez un professionnel du bâtiment ou un particulier en quête
          de solutions efficaces,<br />
          nous avons l’équipement et le savoir-faire pour vous accompagner.<br />
          <br />
          Nous Avons la Solution Complète pour Réaliser Vos Ambitions !
        </p>
        <router-link to="/conteneurs">
          <button class="btn btn-primary py-2 reserver">
            <fa :icon="'calendar-day'" class="icon me-2" /> Réserver un
            conteneur
          </button>
        </router-link>
      </div>
    </div>

    <!-- Section Accueil -->
    <div class="accueil">
      <div class="row py-4 row-cols-1 row-cols-lg-4 accueil-options">
        <a
          v-for="item in sections"
          :key="item.title"
          :href="item.url"
          class="feature col text-decoration-none block-menu mb-4"
        >
          <div class="d-inline-flex align-items-center text-primary fs-4 mb-2">
            <!-- Icône ou image -->
            <fa v-if="item.icon" :icon="item.icon" class="me-4" />
            <img v-else-if="item.image" :src="item.image" class="img-icon" />
            <!-- Titre -->
            <h3 class="fs-5 fw-bold text-body-emphasis d-inline-flex m-0">
              {{ item.title }}
            </h3>
          </div>
          <!-- Description -->
          <p class="text-body">{{ item.description }}</p>
          <!-- Texte de lien -->
          <span class="icon-link text-primary">
            En savoir plus
            <svg class="bi">
              <use xlink:href="#chevron-right" />
            </svg>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      sections: [
        {
          title: 'Conteneurs',
          description:
            'Location de conteneurs pour tous types de déchets et gravats, avec un service rapide et flexible.',
          image: require('@/assets/smallcontainer_yellow.svg'),
          url: '#conteneurs'
        },
        {
          title: 'Matériaux',
          description:
            'Nous fournissons une vaste gamme de matériaux de construction de qualité, adaptés à tous vos projets de construction ou de rénovation.',
          icon: ['fas', 'trowel-bricks'],
          url: '#materiaux'
        },
        {
          title: 'Historique',
          description:
            'Découvrez l’histoire de notre entreprise et comment nous sommes devenus un leader dans le domaine de la location de containers et des travaux de terrassement.',
          icon: ['fas', 'clock'],
          url: '#historique'
        },
        {
          title: 'Terrassements',
          description:
            'Experts en terrassements, nous préparons vos terrains pour tous types de projets de construction ou d’aménagement paysager.',
          icon: ['fas', 'person-digging'],
          url: '#terrassements'
        },
        {
          title: 'Devis',
          description:
            'Obtenez rapidement un devis détaillé et personnalisé pour tous vos besoins en terrassement, transport, et location de conteneurs.',
          icon: ['fas', 'file-invoice-dollar'],
          url: '#devis'
        },
        {
          title: 'Contact',
          description:
            'Nous sommes à votre écoute ! Contactez-nous pour toute question ou demande d’information sur nos services.',
          icon: ['fas', 'envelope'],
          url: '#contact'
        }
      ]
    }
  }
}
</script>

<style scoped>
/* Bannière */
.banner {
  height: 300px;
  display: flex;
  overflow: hidden;
  position: relative;
  margin: 0;
  /* Suppression des padding */
}

/* Animation de l'image */
.animated-image {
  height: 100%;
  max-height: 300px;
  opacity: 0;
  transform: translateX(-100%);
  animation: slide-in 2s forwards;
  /* Ombre autour de l'image */
}

/* Texte Bienvenue */
.welcome-text {
  flex: 1;
  margin-left: 2rem;
  /* opacity: 0; */
  /* animation: fade-in 1s forwards; */
  /* animation-delay: 2s; */
  /* Synchronisation avec l'image */
}

.fade-in-text {
  animation: fade-in 1s forwards;
  animation-delay: 2.5s;
}

/* Responsiveness */
@media (max-width: 768px) {
  .banner {
    flex-direction: column;
    height: auto;
  }

  .animated-image {
    width: 100%;
    height: auto;
    margin-bottom: 1rem;
  }

  .welcome-text {
    margin-left: 0;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 1rem;
  }
}

/* Section Accueil */
.feature-icon {
  width: 3em;
  height: 3em;
  color: #fff;
}

.block-menu {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 3px 9px 0px;
  padding: 1rem;
  gap: 0.25rem;
  border-radius: 6px;
  flex-grow: 1;
}

@media (min-width: 992px) {
  .block-menu {
    margin: 1rem;
  }
}

.img-icon {
  width: 32px;
  height: 32px;
  margin-right: 1rem;
}

/* Animations */
@keyframes slide-in {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.lead {
  text-align: left;
  font-size: 0.95rem;
}
</style>
